import Manager from 'coreClasses/Manager';
import ManagerRepository from 'coreClasses/ManagerRepository';
import CMSProvidersFactory from './CMSProvidersFactory';

/**
 * Represents CMSProvidersMgr
 */
class CMSProvidersMgr extends Manager {
	private factory: CMSProvidersFactory;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @protected
	 */
	constructor(managerRepository: ManagerRepository) {
		super(managerRepository);

		this.factory = new CMSProvidersFactory(managerRepository);
	}

	/**
	 * Returns CMSProvider
	 * @param {String} providerId Provider Id
	 * @returns {CMSProvider}
	 */
	getProvider(providerId) {
		return this.factory.create(providerId);
	}
}

export default CMSProvidersMgr;
